var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page",attrs:{"id":"main"}},[_c('div',{staticStyle:{"min-height":"calc(100vh - 67px)"}},[_c('Navigation'),_vm._v(" "),_c('RouterView',{staticStyle:{"min-height":"100%","margin-bottom":"-50px"}})],1),_vm._v(" "),_c('Footer',{staticStyle:{"height":"67px"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2af3389d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/index.vue
// module id = null
// module chunks = 